import { Col } from 'antd';
import React from 'react';
import { UpdateQueryParams } from '@hooks';
import {
	InactiveToggle,
	InactiveToggleQueryParams,
	SearchFilter,
	SearchFilterContainer,
	SearchFilterQueryParams
} from '../filters';

export type ValidationRuleSearchQueryParams = InactiveToggleQueryParams &
	SearchFilterQueryParams;

export interface ValidationRuleSearchOptions {
	hideInactive: boolean;
	searchText: string;
}

export interface ValidationRuleSearchProps {
	onChange: UpdateQueryParams<ValidationRuleSearchQueryParams>;
	queryParams: ValidationRuleSearchQueryParams;
}

export const defaultValidationRuleSearchOptions: ValidationRuleSearchOptions = {
	hideInactive: false,
	searchText: ''
};

export const ValidationRuleSearch: React.FC<ValidationRuleSearchProps> = ({ onChange, queryParams }) =>
	<SearchFilterContainer>
		<Col span={ 12 }>
			<SearchFilter onChange={ onChange } />
		</Col>
		<Col
			className='align-right'
			span={ 12 }>
			<InactiveToggle
				checked={ Boolean(queryParams.hideInactive) }
				onChange={ onChange } />
		</Col>
	</SearchFilterContainer>;

